(() => {
  function closeDesktopMenus(except) {
    document.querySelectorAll('.mg-desktop-nav--v2 details[open]').forEach((details) => {
      if (details !== except) details.removeAttribute('open');
    });
  }

  function initNavigation() {
    document.querySelectorAll('.mg-desktop-nav--v2 details').forEach((details) => {
      if (details.dataset.mgNavReady === 'true') return;
      details.dataset.mgNavReady = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) closeDesktopMenus(details);
      });
    });
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.mg-desktop-nav--v2 details')) closeDesktopMenus();
    });
    let previousY = window.scrollY;
    window.addEventListener('scroll', () => {
      if (Math.abs(window.scrollY - previousY) > 18) closeDesktopMenus();
      previousY = window.scrollY;
    }, { passive: true });
  }

  function initConfiguratorEcosystem(scope = document) {
    const ecosystem = scope.querySelector?.('.configurator-ecosystem') || document.querySelector('.configurator-ecosystem');
    if (!ecosystem || ecosystem.dataset.mgEcosystemReady === 'true') return false;
    const configurator = ecosystem.querySelector('.configurator-section');
    const community = ecosystem.querySelector('.community-builds');
    if (!configurator || !community) return false;
    ecosystem.dataset.mgEcosystemReady = 'true';
    const bridge = document.createElement('aside');
    bridge.className = 'ecosystem-bridge';
    bridge.setAttribute('aria-label', 'Dal configuratore alla community');
    bridge.innerHTML = '<p>UN UNICO ECOSISTEMA</p><div class="ecosystem-bridge__flow"><span><i>01</i><b>CONFIGURA</b><small>Scegli ogni componente</small></span><em aria-hidden="true">→</em><span><i>02</i><b>SALVA LA BUILD</b><small>La configurazione prende forma</small></span><em aria-hidden="true">→</em><span><i>03</i><b>ENTRA NELLA COMMUNITY</b><small>Le migliori vengono pubblicate qui</small></span></div>';
    community.before(bridge);
    return true;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-mg-cart-count], .cart-count, [data-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count < 1;
    });
    document.querySelectorAll('[aria-label*="articoli nel carrello"]').forEach((badge) => {
      badge.setAttribute('aria-label', count + (count === 1 ? ' articolo nel carrello' : ' articoli nel carrello'));
    });
  }

  function readCartCount() {
    return window.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : Promise.reject(new Error('cart')))
      .then((cart) => {
        updateCartCount(Number(cart.item_count || 0));
        return cart;
      });
  }

  function initSmartCrossSell(scope = document) {
    const modal = scope.querySelector?.('[data-mg-smart-crosssell]') || document.querySelector('[data-mg-smart-crosssell]');
    if (!modal || modal.dataset.mgSmartReady === 'true') return;
    modal.dataset.mgSmartReady = 'true';
    const status = modal.querySelector('[data-mg-smart-status]');
    let opener = null;

    const setStatus = (message) => { if (status) status.textContent = message || ''; };
    const open = (trigger) => {
      opener = trigger || document.activeElement;
      modal.hidden = false;
      document.body.classList.add('mg-smart-crosssell-open');
      setStatus('');
      document.dispatchEvent(new CustomEvent('mg:crosssell-open'));
      window.setTimeout(() => modal.querySelector('.mg-smart-crosssell__close')?.focus(), 30);
    };
    const close = () => {
      modal.hidden = true;
      document.body.classList.remove('mg-smart-crosssell-open');
      opener?.focus?.({ preventScroll: true });
    };

    modal.querySelectorAll('[data-mg-smart-close]').forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden && document.querySelector('[data-mg-product-preview]')?.hidden !== false) close();
    });

    // GPO must remain the owner of the complete multi-item cart payload.
    // We only provide immediate feedback here, then open cross-sell after GPO
    // confirms that the parent product and every selected add-on were added.
    let pendingGpo = null;

    const releaseGpoButton = (button) => {
      if (!button) return;
      button.classList.remove('gpo-loading');
      button.disabled = false;
      button.removeAttribute('disabled');
    };

    const liveGpoButtons = (pending) => {
      const buttons = new Set();
      if (pending?.button) buttons.add(pending.button);
      document.querySelectorAll('.gpo-clone-atc-button').forEach((button) => {
        if (!button.closest('[data-mg-cart-modal], .mg-rex-crosssell')) buttons.add(button);
      });
      return buttons;
    };

    const restoreGpoButton = (pending, state = '') => {
      if (!pending?.button) return;
      liveGpoButtons(pending).forEach((button) => {
        releaseGpoButton(button);
        button.classList.remove('is-adding', 'is-added', 'is-error');
        if (state) button.classList.add(state);
        button.removeAttribute('aria-busy');
        button.innerHTML = pending.original;
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('.gpo-clone-atc-button');
      if (!button) return;
      const form = button.closest('form[action*="/cart/add"]');
      if (!form || form.closest('[data-mg-cart-modal], .mg-rex-crosssell')) return;
      if (form.querySelector('[data-mg-required="true"].is-missing')) return;

      if (pendingGpo?.timer) window.clearTimeout(pendingGpo.timer);
      const original = button.innerHTML;
      button.classList.remove('is-added', 'is-error');
      button.classList.add('is-adding');
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'SALVO LA CONFIGURAZIONE…';
      setStatus('STIAMO AGGIUNGENDO IL PC E TUTTE LE SCELTE GPO…');

      const timer = window.setTimeout(() => {
        if (!pendingGpo || pendingGpo.button !== button) return;
        restoreGpoButton(pendingGpo, 'is-error');
        setStatus('La configurazione sta impiegando più del previsto. Riprova tra poco.');
        pendingGpo = null;
      }, 20000);

      pendingGpo = { form, button, original, timer };
      // Important: do not prevent or stop this click. GPO must receive it.
    }, true);

    document.addEventListener('gpoAddedToCart', () => {
      if (!pendingGpo) return;
      const completed = pendingGpo;
      pendingGpo = null;
      window.clearTimeout(completed.timer);
      open(completed.button);
      setStatus('PC E SCELTE GPO AGGIUNTI CORRETTAMENTE');
      readCartCount().catch(() => {});

      // GPO may replace its cloned button while completing the multi-item request.
      // Resolve the current live button after the event so the visual state survives.
      window.setTimeout(() => {
        liveGpoButtons(completed).forEach((button) => {
          releaseGpoButton(button);
          button.classList.remove('is-adding', 'is-error');
          button.classList.add('is-added');
          button.removeAttribute('aria-busy');
          button.textContent = 'CONFIGURAZIONE AGGIUNTA ✓';
        });
      }, 120);
      window.setTimeout(() => restoreGpoButton(completed), 2600);
      window.setTimeout(() => restoreGpoButton(completed), 5600);
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest?.('form[action*="/cart/add"]');
      if (!form) return;

      if (form.matches('[data-mg-smart-quick]') || form.closest('[data-mg-smart-crosssell]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.dataset.mgSmartProcessing === 'true') return;
        form.dataset.mgSmartProcessing = 'true';
        const button = form.querySelector('button[type="submit"]');
        const original = button?.textContent || 'AGGIUNGI +';
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          button.classList.remove('is-added', 'is-error');
          button.classList.add('is-adding');
          button.textContent = 'AGGIUNGO…';
        }
        window.fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
          .then((response) => response.ok ? response.json() : Promise.reject(new Error('add')))
          .then(() => {
            if (button) {
              button.classList.remove('is-adding');
              button.classList.add('is-added');
              button.textContent = 'AGGIUNTO ✓';
            }
            setStatus('EXTRA AGGIUNTO AL CARRELLO');
            readCartCount().catch(() => {});
          })
          .catch(() => {
            if (button) {
              button.classList.remove('is-adding');
              button.classList.add('is-error');
              button.textContent = 'RIPROVA';
            }
            setStatus('Non siamo riusciti ad aggiungere questo extra. Riprova tra poco.');
          })
          .finally(() => {
            form.dataset.mgSmartProcessing = 'false';
            if (button) {
              button.disabled = false;
              button.removeAttribute('aria-busy');
              window.setTimeout(() => {
                button.textContent = original;
                button.classList.remove('is-added', 'is-error', 'is-adding');
              }, 2800);
            }
          });
        return;
      }

      // GPO cloned forms are handled by the app so its full multi-item payload is preserved.
      if (form.querySelector('.gpo-clone-atc-button')) return;

      const isPrimary = form.matches('[data-mg-standard-form], .mg-rex-pdp__form, [data-type="add-to-cart-form"]')
        || !!form.closest('product-form');
      if (!isPrimary || form.closest('[data-mg-cart-modal], .mg-rex-crosssell, .mg-standard-pc-complete')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.mgSmartProcessing === 'true') return;
      form.dataset.mgSmartProcessing = 'true';
      const button = form.querySelector('button[type="submit"], button[name="add"]');
      const original = button?.innerHTML || '';
      const data = new FormData(form);
      if (!data.get('id')) data.set('id', modal.dataset.mgCurrentVariant || '');
      if (!data.get('id')) {
        form.dataset.mgSmartProcessing = 'false';
        setStatus('Seleziona una configurazione disponibile.');
        return;
      }
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      window.fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data })
        .then((response) => response.ok ? response.json() : response.json().then((body) => Promise.reject(new Error(body.description || 'add'))))
        .then(() => {
          open(button);
          readCartCount().catch(() => {});
        })
        .catch((error) => {
          setStatus(error.message || 'Impossibile aggiungere il prodotto.');
          window.alert(error.message || 'Impossibile aggiungere il prodotto. Riprova.');
        })
        .finally(() => {
          form.dataset.mgSmartProcessing = 'false';
          if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.innerHTML = original; }
        });
    }, true);
  }

  function initCrossSellCarousels(scope = document) {
    const carousels = Array.from(scope.querySelectorAll?.('[data-mg-cross-carousel]') || []);
    carousels.forEach((carousel) => {
      if (carousel.dataset.mgCarouselReady === 'true') return;
      carousel.dataset.mgCarouselReady = 'true';
      const viewport = carousel.querySelector('[data-mg-cross-viewport]');
      const track = carousel.querySelector('[data-mg-cross-track]');
      const previous = carousel.querySelector('[data-mg-cross-prev]');
      const next = carousel.querySelector('[data-mg-cross-next]');
      const count = carousel.querySelector('[data-mg-cross-count]');
      if (!viewport || !track) return;

      const cards = () => Array.from(track.children).filter((card) => !card.hidden);
      const step = () => {
        const visible = cards();
        if (!visible.length) return Math.max(260, viewport.clientWidth * .82);
        const gap = parseFloat(window.getComputedStyle(track).gap || '0') || 0;
        return visible[0].getBoundingClientRect().width + gap;
      };
      const update = () => {
        const visible = cards();
        const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const index = visible.length ? Math.min(visible.length - 1, Math.max(0, Math.round(viewport.scrollLeft / Math.max(1, step())))) : 0;
        if (count) count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(visible.length).padStart(2, '0');
        if (previous) previous.disabled = viewport.scrollLeft <= 3;
        if (next) next.disabled = viewport.scrollLeft >= max - 3 || max <= 3;
      };
      const move = (direction) => viewport.scrollBy({ left: step() * direction, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      viewport.addEventListener('scroll', update, { passive: true });
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
        if (event.key === 'Home') { event.preventDefault(); viewport.scrollTo({ left: 0, behavior: 'smooth' }); }
        if (event.key === 'End') { event.preventDefault(); viewport.scrollTo({ left: viewport.scrollWidth, behavior: 'smooth' }); }
      });
      window.addEventListener('resize', update, { passive: true });
      document.addEventListener('mg:crosssell-open', () => window.setTimeout(update, 40));
      window.setTimeout(update, 40);
    });
  }

  function initProductPreview() {
    const modal = document.querySelector('[data-mg-product-preview]');
    if (!modal || modal.dataset.mgPreviewReady === 'true') return;
    modal.dataset.mgPreviewReady = 'true';
    const image = modal.querySelector('[data-mg-preview-image]');
    const label = modal.querySelector('[data-mg-preview-label]');
    const title = modal.querySelector('[data-mg-preview-title]');
    const copy = modal.querySelector('[data-mg-preview-copy]');
    const detail = modal.querySelector('[data-mg-preview-detail]');
    const specs = modal.querySelector('[data-mg-preview-specs]');
    const price = modal.querySelector('[data-mg-preview-price]');
    const add = modal.querySelector('[data-mg-preview-add]');
    const status = modal.querySelector('[data-mg-preview-status]');
    let opener = null;
    let activeCard = null;

    const focusable = () => Array.from(modal.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter((node) => node.offsetParent !== null);
    const close = () => {
      if (modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('mg-product-preview-open');
      activeCard = null;
      opener?.focus?.({ preventScroll: true });
    };
    const open = (trigger) => {
      const card = trigger.closest('[data-mg-preview-card]');
      if (!card) return;
      activeCard = card;
      opener = trigger;
      const sourceImage = card.querySelector('img');
      if (image && sourceImage) { image.src = sourceImage.currentSrc || sourceImage.src; image.alt = sourceImage.alt || card.dataset.mgPreviewTitle || ''; }
      if (label) label.textContent = card.dataset.mgPreviewLabel || 'ANTEPRIMA PRODOTTO';
      if (title) title.textContent = card.dataset.mgPreviewTitle || '';
      if (copy) copy.textContent = card.dataset.mgPreviewCopy || '';
      if (detail) detail.textContent = card.dataset.mgPreviewDetail || card.dataset.mgPreviewCopy || '';
      if (specs) { specs.textContent = card.dataset.mgPreviewSpecs || 'SELEZIONATO PER LA COMPATIBILITÀ CON IL TUO ACQUISTO'; specs.hidden = false; }
      if (price) price.textContent = card.dataset.mgPreviewPrice || '';
      if (status) status.textContent = '';
      if (add) {
        add.disabled = !card.dataset.mgPreviewVariant;
        add.dataset.variantId = card.dataset.mgPreviewVariant || '';
        add.textContent = card.dataset.mgPreviewVariant ? 'AGGIUNGI AL CARRELLO +' : 'NON DISPONIBILE';
        add.classList.remove('is-added');
      }
      modal.hidden = false;
      document.body.classList.add('mg-product-preview-open');
      window.setTimeout(() => modal.querySelector('.mg-product-preview__close')?.focus(), 30);
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('[data-mg-preview-open]');
      if (trigger) { event.preventDefault(); open(trigger); }
    });
    modal.querySelectorAll('[data-mg-preview-close]').forEach((button) => button.addEventListener('click', close));
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); return; }
      if (event.key !== 'Tab') return;
      const items = focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    document.addEventListener('click', (event) => {
      if (!event.target.closest?.('[data-mg-preview-add]')) return;
      event.preventDefault();
      event.stopPropagation();
      const variantId = add.dataset.variantId;
      if (!variantId || add.disabled) return;
      const original = add.textContent;
      add.disabled = true;
      add.setAttribute('aria-busy', 'true');
      window.fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }).then((response) => response.ok ? response.json() : Promise.reject(new Error('add')))
        .then(() => readCartCount())
        .then(() => {
          add.textContent = 'AGGIUNTO ✓';
          add.classList.add('is-added');
          if (status) status.textContent = (activeCard?.dataset.mgPreviewTitle || 'Prodotto') + ' aggiunto al carrello.';
        })
        .catch(() => { if (status) status.textContent = 'Non siamo riusciti ad aggiungerlo. Riprova tra poco.'; })
        .finally(() => {
          add.disabled = false;
          add.removeAttribute('aria-busy');
          if (!add.classList.contains('is-added')) add.textContent = original;
        });
    });
  }

  function initProductAssurance(scope = document) {
    const groups = [];
    if (scope.matches?.('.mg-rex-assurance__items')) groups.push(scope);
    scope.querySelectorAll?.('.mg-rex-assurance__items').forEach((group) => groups.push(group));
    groups.forEach((group) => {
      if (group.dataset.mgAssuranceReady === 'true') return;
      group.dataset.mgAssuranceReady = 'true';
      const items = Array.from(group.querySelectorAll(':scope > details'));
      items.forEach((item) => item.removeAttribute('open'));
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });
    });
  }

  function initOptionValidation(scope = document) {
    const translate = (root) => {
      const candidates = [];
      if (root?.matches?.('.help-block.error')) candidates.push(root);
      root?.querySelectorAll?.('.help-block.error').forEach((message) => candidates.push(message));
      candidates.forEach((message) => {
        if (/this field is required/i.test(message.textContent || '')) {
          message.textContent = 'Scegli un’opzione per continuare.';
        }
        message.setAttribute('role', 'alert');
        message.setAttribute('aria-live', 'assertive');
      });
    };
    translate(scope);
    if (document.documentElement.dataset.mgOptionValidationReady === 'true') return;
    document.documentElement.dataset.mgOptionValidationReady = 'true';
    const observer = new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) translate(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init(scope = document) {
    if (scope === document || scope.querySelector('.mg-desktop-nav--v2')) initNavigation();
    initConfiguratorEcosystem(scope);
    initSmartCrossSell(scope);
    initCrossSellCarousels(scope);
    initProductPreview();
    initProductAssurance(scope);
    initOptionValidation(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  const ecosystemObserver = new MutationObserver(() => {
    if (initConfiguratorEcosystem()) ecosystemObserver.disconnect();
  });
  ecosystemObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

/* Give wrapped display headings readable leading without loosening single-line titles. */
(() => {
  const selector = 'h1, h2';
  let frame = 0;

  function isMultiline(title) {
    const style = getComputedStyle(title);
    const fontSize = Number.parseFloat(style.fontSize) || 16;
    const height = title.getBoundingClientRect().height;
    return height > fontSize * 1.45;
  }

  function sync(scope = document) {
    const titles = [];
    if (scope.matches?.(selector)) titles.push(scope);
    scope.querySelectorAll?.(selector).forEach((title) => titles.push(title));
    const mgWidth = window.innerWidth;
    titles.forEach((title) => {
      const mgKey = mgWidth + '|' + (title.textContent || '').length;
      if (title.__mgRhythmKey === mgKey) return;
      title.__mgRhythmKey = mgKey;
      const multiline = isMultiline(title);
      title.classList.toggle('mg-title--multiline', multiline);
      if (multiline) {
        title.dataset.mgTitleRhythm = 'true';
        title.style.setProperty('line-height', window.innerWidth <= 820 ? '1.08' : '1.05', 'important');
      } else if (title.dataset.mgTitleRhythm === 'true') {
        delete title.dataset.mgTitleRhythm;
        title.style.removeProperty('line-height');
      }
    });
  }

  function schedule(scope = document) {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => sync(scope));
  }

  function init() {
    schedule();
    document.fonts?.ready.then(() => schedule());
    new MutationObserver(() => schedule()).observe(document.body, { childList: true, subtree: true });
    new ResizeObserver(() => schedule()).observe(document.documentElement);
    document.addEventListener('shopify:section:load', (event) => schedule(event.target));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* Swap the three journey visuals only on phones; desktop keeps its original art direction. */
(() => {
  const mobileImages = [
    ['.journey-card--ready .journey-image', 'https://cdn.shopify.com/s/files/1/0511/1254/2397/files/mg-mobile-pc-pronto-dual-chamber-v2.avif?v=1788444914'],
    ['.journey-card--configurator .journey-image', 'https://cdn.shopify.com/s/files/1/0511/1254/2397/files/mg-mobile-crealo-io-dual-chamber-v2.avif?v=1788444920'],
    ['.journey-card--booster .journey-image', 'https://cdn.shopify.com/s/files/1/0511/1254/2397/files/mg-mobile-piu-fps-dual-chamber-v2.avif?v=1788444926']
  ];

  function syncJourneyImages(scope = document) {
    const mobile = window.matchMedia('(max-width: 600px)').matches;
    mobileImages.forEach(([selector, mobileSrc], index) => {
      const image = scope.querySelector?.(selector) || document.querySelector(selector);
      if (!image) return;
      if (!image.dataset.mgDesktopSrc) image.dataset.mgDesktopSrc = image.currentSrc || image.getAttribute('src') || '';
      const target = mobile ? mobileSrc : image.dataset.mgDesktopSrc;
      if (target && image.getAttribute('src') !== target) image.setAttribute('src', target);
      image.setAttribute('loading', index === 0 ? 'eager' : 'lazy');
      image.setAttribute('decoding', 'async');
      if (index === 0) image.setAttribute('fetchpriority', 'high');
      else image.removeAttribute('fetchpriority');
    });
  }

  function initMobileHomePolish(scope = document) {
    syncJourneyImages(scope);
    const journey = scope.querySelector?.('.journey-grid') || document.querySelector('.journey-grid');
    const products = scope.querySelector?.('.products-grid') || document.querySelector('.products-grid');
    [journey, products].forEach((rail) => {
      if (!rail || rail.dataset.mgSwipeReady === 'true') return;
      rail.dataset.mgSwipeReady = 'true';
      rail.setAttribute('tabindex', '0');
    });
  }

  const start = () => initMobileHomePolish();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.matchMedia('(max-width: 600px)').addEventListener?.('change', () => syncJourneyImages());
  document.addEventListener('shopify:section:load', (event) => initMobileHomePolish(event.target));
  const polishObserver = new MutationObserver(() => {
    initMobileHomePolish();
    if (document.querySelector('.journey-grid') && document.querySelector('.products-grid')) {
      polishObserver.disconnect();
    }
  });
  polishObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

/* Keep long PC names readable and expose only real, product-specific audio. */
(() => {
  let fitFrame = 0;
  let audioId = 0;
  const audioControllers = new WeakMap();

  function productName(root) {
    return (root.querySelector('.mg-rex-hero h1')?.textContent || 'PC GAMING').replace(/\s+/g, ' ').trim();
  }

  function fitProductName(root) {
    const title = root.querySelector('.mg-rex-hero h1');
    if (!title) return;
    title.classList.remove('is-mg-wrapped-title');
    title.style.removeProperty('font-size');
    const words = title.textContent.trim().split(/\s+/).filter(Boolean);
    title.style.setProperty('white-space', words.length === 1 ? 'nowrap' : 'normal', 'important');
    title.style.setProperty('overflow-wrap', 'normal', 'important');
    title.style.setProperty('word-break', 'normal', 'important');
    title.style.setProperty('hyphens', 'none', 'important');
    const available = Math.max(0, title.clientWidth - 2);
    const style = getComputedStyle(title);
    const size = parseFloat(style.fontSize) || 58;
    const canvas = fitProductName.canvas ||= document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context || !available || !words.length) return;
    context.font = `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
    const spacing = parseFloat(style.letterSpacing) || 0;
    const natural = Math.max(...words.map(word => context.measureText(word).width + spacing * (word.length - 1)));
    if (available && natural > available) {
      const fitted = Math.floor(size * available / natural * 100) / 100;
      title.style.setProperty('font-size', `${fitted}px`, 'important');
    }
  }

  window.MGFitProductName = fitProductName;

  function scheduleFit(scope = document) {
    cancelAnimationFrame(fitFrame);
    fitFrame = requestAnimationFrame(() => {
      fitFrame = 0;
      const roots = [...(scope.querySelectorAll?.('.mg-rex-pdp') || [])];
      if (scope.matches?.('.mg-rex-pdp')) roots.unshift(scope);
      roots.forEach(fitProductName);
    });
  }

  function ensureAudioAccess(root) {
    const existingController = audioControllers.get(root);
    if (existingController) {
      existingController.render();
      return;
    }
    const storyTitle = root.querySelector('.mg-rex-story__copy h2, .mg-rex-story h2');
    if (!storyTitle) return;
    let panel = root.querySelector('[data-mg-audio], .mg-rex-audio');
    // Community configurations have no editorial recording assigned by their template.
    if (!panel && root.dataset.mgConfigurator === 'true') return;
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'mg-rex-audio';
      panel.innerHTML = '<button type="button" class="mg-rex-audio__play" data-mg-audio-toggle><span data-mg-audio-icon aria-hidden="true">▶</span></button><div><strong data-mg-profile-audio-label></strong><small></small><span class="mg-rex-audio__wave" aria-hidden="true"></span><em></em></div>';
    }
    panel.setAttribute('data-mg-audio', '');
    panel.classList.remove('mg-rex-audio--video');
    panel.classList.add('mg-rex-audio--podcast');
    panel.removeAttribute('href');
    panel.removeAttribute('data-mg-speaking');
    panel.setAttribute('role', 'group');
    storyTitle.insertAdjacentElement('afterend', panel);

    const button = panel.querySelector('[data-mg-audio-toggle], button');
    if (!button) return;
    const label = panel.querySelector('[data-mg-profile-audio-label], strong');
    const meta = panel.querySelector('small');
    const status = panel.querySelector('em');
    const icon = panel.querySelector('[data-mg-audio-icon]');
    if (!panel.id) panel.id = `MgProductPodcast-${++audioId}`;
    if (status) {
      status.id = `${panel.id}-status`;
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      button.setAttribute('aria-describedby', status.id);
    }

    function mediaUrl(value) {
      if (typeof value !== 'string' || !value.trim()) return '';
      try {
        const url = new URL(value.trim(), window.location.href);
        if (url.username || url.password) return '';
        if (url.protocol !== 'https:' && !(url.protocol === 'http:' && url.origin === window.location.origin)) return '';
        if (/(^|\.)(youtube\.com|youtube-nocookie\.com|youtu\.be)$/i.test(url.hostname)) return '';
        return url.href;
      } catch (_) { return ''; }
    }

    let media = panel.querySelector('audio[data-mg-audio-player]');
    const templateSource = mediaUrl(media?.getAttribute('src') || media?.querySelector('source[src]')?.getAttribute('src'));
    if (!media) {
      media = document.createElement('audio');
      media.setAttribute('data-mg-audio-player', '');
      panel.appendChild(media);
    }
    media.setAttribute('data-mg-podcast-native', '');
    media.id = `${panel.id}-media`;
    media.autoplay = false;
    media.removeAttribute('autoplay');
    media.loop = false;
    media.preload = 'none';
    media.crossOrigin = 'anonymous';
    button.type = 'button';
    button.setAttribute('aria-controls', media.id);
    let source = null;
    let loading = false;
    let failed = false;
    let profileReceived = false;
    let presentationSource = '';
    let playAttempt = 0;
    let iconState = '';

    function render() {
      const name = productName(root);
      const playing = Boolean(source && !media.paused && !media.ended && !failed);
      const state = !source ? 'unavailable' : failed ? 'error' : loading ? 'loading' : playing ? 'playing' : media.ended ? 'ended' : media.currentTime > 0 ? 'paused' : 'ready';
      panel.dataset.mgAudioState = state;
      panel.classList.toggle('is-disabled', !source);
      button.disabled = !source;
      button.classList.toggle('is-playing', playing);
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-busy', String(loading));
      panel.setAttribute('aria-label', `Presentazione audio di ${name}`);
      if (label) label.textContent = `ASCOLTA COM’È FATTO IL ${name.toUpperCase()}`;
      button.setAttribute('aria-label', !source ? `Audio di ${name} in preparazione` : failed ? `Riprova la presentazione audio di ${name}` : `${playing ? 'Metti in pausa' : 'Riproduci'} la presentazione audio di ${name}`);
      const duration = Number.isFinite(media.duration) && media.duration > 0 ? Math.round(media.duration) : Math.round(Number(media.dataset.mgAudioDuration) || 0);
      const elapsed = Math.max(0, Math.floor(media.currentTime || 0));
      const timeLabel = (seconds) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
      if (meta) meta.textContent = !source ? 'AUDIO IN PREPARAZIONE' : `GUIDA AUDIO${duration ? ` · ${timeLabel(elapsed)} / ${timeLabel(duration)}` : ''}`;
      if (status) status.textContent = ({ unavailable: 'La presentazione sarà disponibile qui.', error: 'Audio non disponibile. Riprova.', loading: 'Caricamento audio…', playing: 'IN RIPRODUZIONE', paused: 'IN PAUSA · RIPRENDI', ended: 'RIASCOLTA LA PRESENTAZIONE', ready: 'PREMI PLAY' })[state];
      const nextIconState = playing ? 'pause' : 'play';
      if (icon && iconState !== nextIconState) {
        iconState = nextIconState;
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = playing
          ? '<svg viewBox="0 0 24 24" width="27" height="27" fill="currentColor" aria-hidden="true"><path d="M6 4h4v16H6zm8 0h4v16h-4z"/></svg>'
          : '<svg viewBox="0 0 24 24" width="27" height="27" fill="currentColor" aria-hidden="true"><path d="M6 3v18l15-9z"/></svg>';
      }
    }

    function setSource(value) {
      const next = mediaUrl(value);
      if (next === source) { render(); return; }
      playAttempt += 1;
      media.pause();
      loading = false;
      failed = false;
      source = next;
      media.querySelectorAll('source').forEach((node) => node.remove());
      // Keep the file detached until an explicit play click: load() can ignore
      // preload="none" on some browsers when a source is already assigned.
      media.dataset.mgAudioSource = source || '';
      media.removeAttribute('src');
      media.load();
      render();
    }

    // Capture before the legacy product handler so one click never toggles twice.
    panel.addEventListener('click', async (event) => {
      if (!event.target.closest('[data-mg-audio-toggle]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!source) return;
      if (!media.paused || loading) {
        playAttempt += 1;
        media.pause();
        loading = false;
        render();
        return;
      }
      const attempt = ++playAttempt;
      if (media.getAttribute('src') !== source) media.src = source;
      if (failed) media.load();
      failed = false;
      loading = true;
      render();
      document.querySelectorAll('audio[data-mg-podcast-native]').forEach((other) => {
        if (other !== media) other.pause();
      });
      try {
        await media.play();
      } catch (error) {
        if (attempt !== playAttempt || error?.name === 'AbortError') return;
        failed = true;
      } finally {
        if (attempt === playAttempt) { loading = false; render(); }
      }
    }, true);

    ['loadedmetadata', 'durationchange', 'timeupdate', 'play', 'playing', 'pause', 'ended', 'waiting', 'stalled', 'error'].forEach((eventName) => {
      media.addEventListener(eventName, () => {
        if (eventName === 'error') { failed = Boolean(source); loading = false; }
        else if (eventName === 'waiting' || eventName === 'stalled') loading = Boolean(source && !media.paused);
        else if (eventName === 'playing' || eventName === 'pause' || eventName === 'ended') loading = false;
        render();
      });
    });

    function applyProfile(profile) {
      profileReceived = true;
      const product = profile?.product || {};
      setSource(presentationSource || mediaUrl(product.podcastUrl || product.audioUrl || product.audio_url) || templateSource);
      scheduleFit(root);
    }
    audioControllers.set(root, { render });
    root.addEventListener('mg:product-profile', (event) => applyProfile(event.detail));
    root.addEventListener('mg:podcast-refresh', render);
    root.addEventListener('mg:audio-source', (event) => {
      const entry = event.detail;
      if (!entry || entry.handle !== root.dataset.mgProductHandle) return;
      presentationSource = mediaUrl(entry.url);
      if (!presentationSource) return;
      media.dataset.mgAudioDuration = String(Number(entry.duration) || 0);
      setSource(presentationSource);
    });
    setSource(templateSource);
    // A cached/inline profile can finish before this companion script mounts.
    const inline = root.querySelector('[data-mg-inline-profile]');
    if (inline?.textContent.trim()) {
      try {
        let profile = JSON.parse(inline.textContent);
        if (typeof profile === 'string') profile = JSON.parse(profile);
        applyProfile(profile);
      } catch (_) {}
    }
    window.setTimeout(() => {
      if (profileReceived || !root.isConnected || !root.dataset.mgProfileUrl) return;
      const profileUrl = mediaUrl(root.dataset.mgProfileUrl);
      if (!profileUrl) return;
      fetch(profileUrl, { credentials: 'same-origin' })
        .then((response) => response.ok ? response.json() : null)
        .then((profile) => { if (profile && !profileReceived && root.isConnected) applyProfile(profile); })
        .catch(() => { /* An absent profile must never enable a placeholder recording. */ });
    }, 1200);
  }

  function unifyStoryAndMachine(root) {
    const story = root.querySelector('.mg-rex-story');
    const machine = root.querySelector('.mg-rex-machine');
    const rail = machine?.querySelector('.mg-rex-machine__rail');
    if (!story || !machine || !rail) return;
    story.classList.add('is-mg-machine-intro');
    machine.classList.add('is-mg-unified-machine');
    if (machine.querySelector('.mg-rex-machine__cta')) return;
    const cta = document.createElement('a');
    cta.className = 'mg-rex-machine__cta';
    cta.href = '#personalizza-rex';
    cta.innerHTML = '<span>PERSONALIZZA IL TUO PC</span><b aria-hidden="true">→</b>';
    rail.insertAdjacentElement('afterend', cta);

    const syncCta = () => {
      const name = productName(root);
      const label = cta.querySelector('span');
      if (label) label.textContent = `PERSONALIZZA ${name}`;
      cta.setAttribute('aria-label', `Vai alla personalizzazione di ${name}`);
    };
    syncCta();
    root.addEventListener('mg:product-profile', syncCta);
  }

  function init(scope = document) {
    const roots = [...(scope.querySelectorAll?.('[data-mg-rex-pdp]') || [])];
    if (scope.matches?.('[data-mg-rex-pdp]')) roots.unshift(scope);
    roots.forEach((root) => {
      ensureAudioAccess(root);
      unifyStoryAndMachine(root);
    });
    const productRoots = [...(scope.querySelectorAll?.('.mg-rex-pdp') || [])];
    if (scope.matches?.('.mg-rex-pdp')) productRoots.unshift(scope);
    productRoots.forEach(fitProductName);
  }

  const start = () => {
    init();
    scheduleFit();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.fonts?.ready?.then(() => scheduleFit());
  window.addEventListener('resize', () => scheduleFit(), { passive: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

/* Preload the configurator artwork shortly before it enters the viewport. */
(() => {
  let armed = false;

  function armConfiguratorArtwork(scope = document) {
    if (armed) return true;
    const section = scope.querySelector?.('.configurator-ecosystem') || document.querySelector('.configurator-ecosystem');
    const image = section?.querySelector('.configurator-exploded img');
    if (!section || !image) return false;
    armed = true;

    const warm = () => {
      if (image.dataset.mgPrewarmed === 'true') return;
      image.dataset.mgPrewarmed = 'true';
      image.loading = 'eager';
      image.decoding = 'async';
      image.fetchPriority = 'low';
      const source = image.currentSrc || image.getAttribute('src');
      if (!source || document.head.querySelector(`link[data-mg-configurator-preload="${CSS.escape(source)}"]`)) return;
      const preload = document.createElement('link');
      preload.rel = 'preload';
      preload.as = 'image';
      preload.href = source;
      preload.dataset.mgConfiguratorPreload = source;
      document.head.append(preload);
    };

    if (!('IntersectionObserver' in window)) {
      window.setTimeout(warm, 900);
      return true;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      warm();
    }, { rootMargin: '1400px 0px', threshold: 0 });
    observer.observe(section);
    return true;
  }

  const start = () => {
    if (armConfiguratorArtwork()) return;
    const observer = new MutationObserver(() => {
      if (!armConfiguratorArtwork()) return;
      observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 12000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => armConfiguratorArtwork(event.target));
})();

(() => {
  'use strict';

  function cleanName(root) {
    return (root.querySelector('.mg-rex-hero h1')?.textContent || 'PC').replace(/\s+/g, ' ').trim();
  }

  function companionAsset(filename) {
    const source = [...document.scripts].find((script) => /mg-v2-refinements(?:\.min)?\.js/i.test(script.src));
    return new URL(filename, source?.src || window.location.href).href;
  }

  function setHighlightedText(element, value) {
    if (!element) return;
    const parts = String(value).split(/(WARZONE|FORTNITE)/gi);
    element.textContent = '';
    parts.forEach((part) => {
      if (/^(WARZONE|FORTNITE)$/i.test(part)) {
        const highlight = document.createElement('strong');
        highlight.className = 'mg-rex-story__game';
        highlight.textContent = part;
        element.appendChild(highlight);
      } else {
        element.appendChild(document.createTextNode(part));
      }
    });
  }

  function specName(root, index, fallback) {
    const value = root.querySelector(`[data-mg-spec-index="${index}"] [data-mg-spec-label]`)?.textContent;
    return (value || fallback).replace(/\s+/g, ' ').trim();
  }

  function syncReferenceStory(root, name, storyTitle, audio) {
    const story = storyTitle?.closest('.mg-rex-story');
    const machine = root.querySelector('.mg-rex-machine');
    const rail = machine?.querySelector('.mg-rex-machine__rail');
    const machineShell = machine?.querySelector('.mg-rex-shell');
    if (!story || !machine || !rail || !machineShell) return;

    const isFixedBuild = root.classList.contains('is-configurator-build') || root.classList.contains('is-mg-fixed-build');
    root.classList.add('is-mg-reference-story');
    root.classList.toggle('is-mg-fixed-build', isFixedBuild);
    story.classList.add('is-mg-reference-story');
    machine.classList.add('is-mg-reference-story');
    storyTitle.textContent = `PC GAMING ${name.toUpperCase()}. POTENZA CHE SI SENTE.`;

    const cpu = specName(root, 0, 'PROCESSORE GAMING');
    const gpu = specName(root, 1, 'SCHEDA VIDEO GAMING');
    const intro = story.querySelector('[data-mg-story-intro]');
    const performance = story.querySelector('[data-mg-story-performance]');
    const customize = story.querySelector('[data-mg-story-customize]');
    if (intro) intro.textContent = `${name} nasce per trasformare ogni partita in una risposta immediata.`;
    setHighlightedText(performance, `La ${gpu} e il ${cpu} lavorano insieme per offrirti frame rate elevati, immagini fluide e controllo anche nei momenti più intensi. Dalle sfide competitive di Warzone e Fortnite ai mondi aperti più impegnativi, hai una macchina solida, reattiva e pronta a crescere con te.`);
    if (customize) {
      customize.textContent = isFixedBuild
        ? 'La configurazione è già completa, assemblata e testata dai nostri tecnici: ogni componente indicato è incluso nel prezzo mostrato.'
        : `La configurazione base è già completa, assemblata e testata dai nostri tecnici; nella personalizzazione puoi rendere ${name} ancora più tuo scegliendo soltanto upgrade compatibili.`;
    }

    const machineTitle = machine.querySelector('.mg-rex-machine__heading h2');
    const machineAccent = machineTitle?.querySelector('em');
    if (machineTitle && machineAccent) {
      machineTitle.classList.toggle('is-mg-long-machine-title', name.length > 8);
      const first = machineTitle.querySelector('span');
      if (first) first.textContent = 'DENTRO';
      machineAccent.textContent = `${name.toUpperCase()}.`;
    }

    const guideLead = machine.querySelector('[data-mg-profile-machine-guide]');
    if (guideLead) guideLead.textContent = isFixedBuild
      ? 'QUESTA È LA CONFIGURAZIONE COMPLETA DELLA BUILD.'
      : 'QUESTA È LA CONFIGURAZIONE BASE INCLUSA NEL PREZZO.';

    const typeLabels = [
      'CPU INCLUSA',
      'GPU INCLUSA',
      'SCHEDA MADRE INCLUSA',
      'RAM INCLUSA',
      'DISSIPAZIONE INCLUSA',
      'SSD INCLUSO',
      'ALIMENTATORE CERTIFICATO'
    ];
    const typeLabelsByKey = {
      cpu: 'CPU INCLUSA',
      gpu: 'GPU INCLUSA',
      board: 'SCHEDA MADRE INCLUSA',
      mobo: 'SCHEDA MADRE INCLUSA',
      memory: 'RAM INCLUSA',
      ram: 'RAM INCLUSA',
      cooler: 'DISSIPAZIONE INCLUSA',
      storage: 'SSD INCLUSO',
      ssd: 'SSD INCLUSO',
      psu: 'ALIMENTATORE CERTIFICATO',
      case: 'CASE INCLUSO',
      monitor: 'MONITOR INCLUSO',
      mouse: 'MOUSE INCLUSO',
      keyboard: 'TASTIERA INCLUSA',
      headset: 'CUFFIE INCLUSE'
    };
    rail.querySelectorAll('[data-mg-spec-index]').forEach((card) => {
      const index = Number(card.dataset.mgSpecIndex);
      const key = String(card.dataset.mgSpecKey || '').toLowerCase();
      const copy = card.querySelector(':scope > span');
      if (!copy) return;
      let type = copy.querySelector('.mg-rex-spec__type');
      if (!type) {
        type = document.createElement('span');
        type.className = 'mg-rex-spec__type';
        copy.prepend(type);
      }
      type.textContent = typeLabelsByKey[key] || typeLabels[index] || 'COMPONENTE INCLUSO';
    });

    const booster = root.querySelector('.mg-rex-story__booster');
    const cta = machine.querySelector('.mg-rex-machine__cta');
    if (booster) {
      booster.classList.add('mg-rex-machine__booster');
      booster.textContent = `Al checkout puoi aggiungere Minimal Booster a ${name}: ottimizzazione, stress test e profilo su misura per completare l’esperienza e ricevere una macchina realmente definita.`;
      let boosterIcon = booster.querySelector('img');
      if (!boosterIcon) {
        boosterIcon = document.createElement('img');
        boosterIcon.alt = '';
        boosterIcon.width = 72;
        boosterIcon.height = 72;
        booster.prepend(boosterIcon);
      }
      boosterIcon.src = companionAsset('mg-booster-bolt-v1.webp');
      rail.insertAdjacentElement('afterend', booster);
    }

    if (cta) {
      const label = cta.querySelector('span');
      if (label) label.textContent = `PERSONALIZZA ${name.toUpperCase()}`;
      let note = machineShell.querySelector('.mg-rex-machine__cta-note');
      if (!note) {
        note = document.createElement('small');
        note.className = 'mg-rex-machine__cta-note';
        cta.insertAdjacentElement('afterend', note);
      }
      note.textContent = isFixedBuild
        ? 'CONFIGURAZIONE COMPLETA · TORNA ALL’ACQUISTO'
        : 'SCEGLI GLI UPGRADE COMPATIBILI';
    }

    if (audio) {
      const wave = audio.querySelector('.mg-rex-audio__wave');
      if (wave && !wave.querySelector('[data-mg-audio-spectrum]')) {
        let image = wave.querySelector('img');
        if (!image) {
          wave.textContent = '';
          image = document.createElement('img');
          image.alt = '';
          image.width = 620;
          image.height = 207;
          wave.appendChild(image);
        }
        image.src = companionAsset('mg-rex-podcast-wave-v1.webp');
      }
    }
  }

  function syncPurchaseHierarchy(root) {
    const promo = root.querySelector('.mg-rex-promo-card, [data-mg-copy-code]');
    if (promo) {
      promo.classList.add('is-mg-code-control');
      const label = promo.querySelector('[data-mg-profile-promo-label], :scope > span');
      const hint = promo.querySelector('[data-mg-copy-label], small');
      const discount = promo.querySelector('[data-mg-profile-promo-discount], em');
      if (label) label.textContent = 'CODICE SCONTO';
      if (hint && !promo.classList.contains('is-copied')) hint.textContent = 'TOCCA PER COPIARE';
      if (discount) discount.hidden = true;
      let icon = promo.querySelector('.mg-rex-promo-card__copy-icon');
      if (!icon) {
        icon = document.createElement('img');
        icon.className = 'mg-rex-promo-card__copy-icon';
        icon.alt = '';
        icon.width = 24;
        icon.height = 24;
        promo.appendChild(icon);
      }
      icon.src = companionAsset('mg-icon-copy-lucide-v1.svg');
    }

    const pricePanel = root.querySelector('.mg-rex-price-panel');
    if (pricePanel) pricePanel.classList.add('is-mg-centered-price');
  }

  function syncProductHero(root) {
    const name = cleanName(root);
    const kicker = root.querySelector('.mg-rex-hero .mg-rex-kicker');
    const storyTitle = root.querySelector('.mg-rex-story__copy h2, .mg-rex-story h2');
    const audio = root.querySelector('[data-mg-audio]');

    if (kicker) kicker.textContent = 'PC GAMING';

    if (audio && storyTitle && storyTitle.nextElementSibling !== audio) {
      storyTitle.insertAdjacentElement('afterend', audio);
    }

    const audioLabel = audio?.querySelector('[data-mg-profile-audio-label], strong');
    if (audioLabel) audioLabel.textContent = `ASCOLTA COM’È FATTO IL ${name.toUpperCase()}`;

    root.dispatchEvent(new CustomEvent('mg:podcast-refresh'));
    root.classList.toggle('has-mg-story-audio', Boolean(audio && !audio.hidden));
    syncPurchaseHierarchy(root);
    syncReferenceStory(root, name, storyTitle, audio);
  }

  function mount(root) {
    if (!root) return;
    if (root.dataset.mgStoryAudioLayout === 'true') {
      syncProductHero(root);
      return;
    }

    root.dataset.mgStoryAudioLayout = 'true';
    syncProductHero(root);
    root.addEventListener('mg:product-profile', () => requestAnimationFrame(() => syncProductHero(root)));

    const title = root.querySelector('.mg-rex-hero h1');
    if (title) {
      new MutationObserver(() => syncProductHero(root)).observe(title, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    window.setTimeout(() => syncProductHero(root), 350);
    window.setTimeout(() => syncProductHero(root), 1400);
  }

  function init(scope = document) {
    if (scope.matches?.('[data-mg-rex-pdp]')) mount(scope);
    scope.querySelectorAll?.('[data-mg-rex-pdp]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

